<template>
  <generic-modal :title="$t('classroom')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <generic-dropdown
            :title="$t('professor')"
            :placeholder="$t('select one')"
            url="/staff/member/catalog"
            :display_function="
              (itm) => `${itm.first_name} ${itm.first_surname}`
            "
            value_field="member_id"
            @selected="set_professor"
            ref="professor_dropdown"
            :is_multiple="false"
          />
        </div>
        <div class="column">
          <generic-dropdown
            :title="$t('course')"
            :placeholder="$t('select one')"
            url="/student/course/catalog"
            name_field="name"
            value_field="course_id"
            @selected="set_course"
            ref="course_dropdown"
            :is_multiple="false"
          />
        </div>
      </div>
      <div class="columns" v-if="meta && meta.settings">
        <div class="column">
          <div class="field">
            <label class="label"> {{ $t("virtual classroom url") }} </label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.virtual_classroom_url"
                placeholder="https://meet.google.com/abc-defg-hij"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "SectionAssignModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.period_id || !v.meta.professor_id || !v.meta.course_id;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    create(period) {
      let v = this;
      v.set_initial_state();
      v.meta.period_id = period.period_id;
      if (period.course_id) v.$refs.course_dropdown.set_value(period.course_id);
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (v.meta.uuid) {
        put("/student/classroom", { ...v.meta })
          .then(() => {
            v.$emit("classroom_updated");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/student/classroom", { ...v.meta })
          .then(() => {
            v.$emit("classroom_created");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.$refs.professor_dropdown.clear();
      v.$refs.course_dropdown.clear();
      v.error = "";
    },
    set_professor(professor) {
      let v = this;
      if (professor) v.meta.professor_id = professor.member_id;
    },
    set_course(course) {
      let v = this;
      if (course) v.meta.course_id = course.course_id;
    },
    edit(classroom) {
      let v = this;
      v.set_initial_state();
      get("/student/classroom", { uuid: classroom.uuid })
        .then((response) => {
          v.meta = {
            professor_id: response.professor_id,
            course_id: response.course_id,
            settings: response.settings,
            uuid: response.uuid,
            period_id: response.period_id,
          };
          if (response.course_id)
            v.$refs.course_dropdown.set_value(response.course_id);
          if (response.professor_id)
            v.$refs.professor_dropdown.set_value(response.professor_id);
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
